/* stylelint-disable no-descending-specificity */

import styled from '@emotion/styled'
import { COLORS } from 'global-styles'

const border_color = '#e1e1e1'

export const TableStyles = styled.div`
	display: block;
	overflow: auto;

	.table {
		background-color: #fff;
		margin: 0;
		color: inherit;
		&.loading {
			background-color: rgba(255, 255, 255, 0.5);
		}

		.thead {
			border-bottom: 1px solid ${border_color};
		}

		.tbody {
			position: relative;
			.tr:hover {
				background-color: #e7e7e7;
				> .td {
				background-color: #e7e7e7; //covers the whole background of the table when in a smaller screen
				}
			}
			.thead .tr:hover {
				background-color: unset;
			}

			.tr {
				border-bottom: 1px solid ${border_color};
			}
			.tr:last-of-type {
				border-bottom: 0;
			}

			.sub-component {
				background-color: ${COLORS.backgroundGrey};
				padding: 0.5rem 2rem 1.5rem;
				border-bottom: 1px solid ${border_color};
			}
			.table {
				background-color: ${COLORS.backgroundGrey};
				max-width: 800px;
			}
		}

		.th,
		.td {
			background-color: #fff; //covers the whole background of the table when in a smaller screen
			position: relative;
			margin: 0;
			min-height: 40px;

			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			&.white-space-normal {
				white-space: normal;
			}
		}
		.th {
			font-weight: bold;
			padding: 1em;

			border-top: 0.2em solid transparent;
			border-bottom: 0.2em solid transparent;
			border-right: 1px solid ${border_color};

			&.header-sort-asc {
				border-bottom-color: ${border_color};
			}

			&.header-sort-desc {
				border-top-color: ${border_color};
			}
		}
		.th:last-of-type {
			border-right: 0;
		}
		.td {
			padding: 1em 1.5em;
			&.expander-column {
				padding: 1em;
			}
			display: flex;
			justify-content: center;
			flex-direction: column;
		}
		.resizer {
			position: absolute;
			right: 0;
			top: 0;
			height: 100%;
			width: 4px;
			background-color: transparent;
		}

		.status-message {
			opacity: 1;
		}

		&.compact {
			.th,
			.td {
				padding: 0.5em 1em;
				min-height: 20px;
			}
		}
	}
	.table-controls {
		padding: 1em 2.5em 0 1em;

		.pagination-element {
			margin: 4px 20px;

			.page-number-input {
				width: 3em;
				padding-left: 6px;
			}
			.rows-per-page {
				width: 4em;
			}
		}
		.pagination-element:disabled {
			color: #bbb;
		}
	}
	.page-number-input,
	.rows-per-page,
	.filter-input {
		border: 1px solid ${border_color};
		height: 1.9em;
		font: inherit;
		color: inherit;
		background-color: #fff;
	}
	.filter-input {
		width: 100%;
		flex-grow: 1;
		padding-left: 6px;
		font-weight: normal;
		margin-top: 0.3rem;
	}
`

